import type { MenuTypeEnum } from '@/api/hanly/hanlyAPI.schemas';
import { isMenuHidden } from '@/contexts/auth-context';
import { useAuth } from './auth';

/**
 * メニューの表示制御を扱うためのカスタムフック
 */
export const useMenuVisibility = () => {
  const { menuVisibilitySettings } = useAuth();

  /**
   * 指定されたメニューを表示するかどうかを判定（デフォルトは表示）
   */
  const isVisible = (menuType: MenuTypeEnum): boolean => {
    return !isMenuHidden(menuVisibilitySettings, menuType);
  };

  return {
    menuVisibilitySettings,
    isVisible,
  };
};
